"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CartItem = void 0;
var BaseEntity_1 = require("../../../models/concrete/BaseEntity");
;
var CartItem = /** @class */ (function (_super) {
    __extends(CartItem, _super);
    function CartItem(data) {
        var _this = _super.call(this, data) || this;
        _this.product = {
            allowOutOfStock: data.product.allow_out_of_stock,
            brand: data.product.brand,
            category: data.product.category,
            code: data.product.code,
            id: data.product.id,
            imageId: data.product.image_id,
            imageIds: data.product.images_ids,
            name: data.product.name,
            newPrice: data.product.price_new,
            oldPrice: data.product.price_old,
            quantity: data.product.quantity,
            depth: data.product.depth,
            height: data.product.height,
            weight: data.product.weight,
            width: data.product.width,
            volume: data.product.volume,
            seats: data.product.seats,
            hasModifications: data.product.has_modifications,
            hasOptions: data.product.has_options,
            isProductSet: data.product.is_product_set,
            isNotAvailable: data.product.is_not_available,
            modificationsCount: data.product.modifications_count,
            optionGroupsCount: data.product.option_groups_count,
            sku: data.product.sku,
            reviewsCount: data.product.reviews_count,
            reviewsRating: data.product.reviews_rating,
            productSetChildrenCount: data.product.product_set_children_count,
            shortCharacteristics: data.product.short_characteristics,
            characteristicGroup: data.product.characteristicGroup,
            characteristicGroupId: data.product.characteristic_group_id,
            productSetImageDots: data.product.product_set_image_dots,
            productSetParents: data.product.productSetParents,
            files: data.product.files,
            options: data.product.options,
            optionsGroups: data.product.optionsGroups,
            bonusValue: data.product.bonus_value,
            url: data.product.url,
            unit: data.product.unit,
            totalBonusValue: data.product.bonus_value_total,
            isBonusesOutcoming: data.product.is_bonuses_outcoming,
            createdAt: data.product.created_at,
            updatedAt: data.product.updated_at,
            exchangeUpdatedAt: data.product.exchange_updated_at,
            additionalCategories: data.product.additionalCategories,
        };
        _this.customDataFields = data.customDataFields;
        _this.options = data.options;
        _this.optionsGroups = data.optionsGroups;
        _this.data = data.data;
        _this.sum = data.sum;
        _this.quantity = data.quantity;
        _this.price = data.price;
        _this.oldPrice = data.price_old;
        _this.modification = data.modification ? {
            code: data.modification.code,
            id: data.modification.id,
            name: data.modification.name,
            oldPrice: data.modification.price_old,
            price: data.modification.price,
            quantity: data.modification.quantity,
            variants: data.modification.variants.map(function (v) {
                return {
                    group: v.group,
                    id: v.id,
                    image: v.image,
                    value: v.value
                };
            })
        } : undefined;
        return _this;
    }
    return CartItem;
}(BaseEntity_1.BaseEntity));
exports.CartItem = CartItem;
;
//# sourceMappingURL=CartItem.js.map